export default __webpack_public_path__ + "static/media/cvod-R15.00b7512f.svg";